module.exports = __webpack_public_path__ + "media/images/cms/img_slide_15-4897d36af823ae1ca57e1f92c311c16a.jpg";